module.exports = __webpack_public_path__ + "media/images/pipette-141e50ed54a3ac18ab40cb9868000e00.svg";